import { CustomerBusinessType, CustomerTaxIdType } from 'src/constants/customer/enums'
import * as Yup from 'yup'

export const CustomerOnboardingBusinessInformationSchema = Yup.object().shape({
  companyName: Yup.string().required('Business name is required'),
  businessType: Yup.string().required('Business type is required'),
  otherBusinessType: Yup.string().when('businessType', {
    is: CustomerBusinessType.Other,
    then: (schema) => schema.required('Other business type is required'),
  }),
  dotNumber: Yup.string(),
  addressStreet1: Yup.string().required('Address is required'),
  addressStreet2: Yup.string(),
  addressCity: Yup.string().required('City is required'),
  addressState: Yup.string().required('State is required'),
  addressPostalCode: Yup.string()
    .required('Zip code is required')
    .min(5, 'Zip code should have 5 digits'),
  taxIdType: Yup.string().required('Tax identification type is required'),
  ein: Yup.string().when('taxIdType', {
    is: CustomerTaxIdType.Ein,
    then: (schema) => schema.required('EIN is required').min(10, 'EIN number should have 9 digits'),
  }),
  itin: Yup.string().when('taxIdType', {
    is: CustomerTaxIdType.Itin,
    then: (schema) =>
      schema.required('ITIN is required').min(11, 'ITIN number should have 9 digits'),
  }),
})
